export function quotationsListSelector(state) {
  const ids = quotationsListStateSelector(state).items
  return ids.map((id) => state.entities.quotations[id])
}

export function quotationsListStateSelector(state) {
  return state.local.quotations.list
}
